<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="8" @click="back"><img class="back-icon"
                                                         src="@/assets/theme/light/status/01dailyActive/01back.svg">
                    </van-col>
                    <van-col span="8">
                        <div class="banner-title">{{ $t('planLibrary.title') }}</div>
                    </van-col>
                    <van-col span="8">
                        <!--                        <div class="history">{{ $t('planLibrary.history') }}</div>-->
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="create-box" @click="createPlan" v-if="showAddBox">
                <img class="create-icon" src="@/assets/theme/light/trainPlan/07planLibrary/01bg.png">
                <div class="create-text">{{ $t('planLibrary.create') }}</div>
            </div>
            <div v-else>
                <div class="progress-box" v-if="userTrainPlanList.length > 0">
                    <div class="box-title">{{ $t('planLibrary.progress') }}</div>
                    <div class="progress-item" v-for="item in userTrainPlanList"
                         @click="toPlanDesc(item.userPlanId, 1)">
                        <div class="progress-item-title">{{ item.planName }}</div>
                        <div class="progress-item-group">{{ item.groupCount }}{{ $t('planLibrary.group') }} |
                            {{ item.totalCapacity }}{{ $t('planLibrary.capacity') }}
                        </div>
                        <div class="progress-item-date">
                            {{ getRepeatWeekText(item.weeklyRepeat) }}（{{ item.startDate }}~{{ item.endDate }}）
                        </div>
                    </div>
                </div>
                <div class="plan-box">
                    <div class="box-title">{{ $t('planLibrary.title') }}
                        <img class="add-icon" @click="createPlan"
                             src="@/assets/theme/light/trainPlan/01planEdit/01add.svg">
                    </div>

                    <div class="progress-item" v-for="item in planLibraryList" @click="toPlanDesc(item.planId, 0)">
                        <div class="progress-item-title">{{ item.planName }}</div>
                        <div class="progress-item-info">
                            <span class="info-type">{{ $t('planLibrary.action') }}</span>
                            <span class="info-value">{{ item.actionCount }}</span>
                            <span class="info-type">{{ $t('planLibrary.groupCount') }}</span>
                            <span class="info-value">{{ item.groupCount }}</span>
                            <span class="info-type">{{ $t('planLibrary.capacity') }}</span>
                            <span class="info-value">{{ item.totalCapacity }}</span>
                        </div>
                        <img class="desc-icon" src="@/assets/theme/light/trainPlan/07planLibrary/02desc.svg">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'planLibrary',
    data() {
        return {
            showAddBox: false,
            planLibraryList: [],
            userTrainPlanList: [],
            from: '',
            theme: 'light'
        }
    },
    mounted() {
        this.getPlanLibrary();
        this.getUserTrainPlan();
        if (this.$route.query.from) {
            this.from = 'web';
        }
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme;
        }
    },
    methods: {
        back() {
            if (this.from === 'web') {
                this.$router.back();
            } else {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            }
        },
        getPlanLibrary() {
            this.$api.trainPlan.getPlanLibrary().then(res => {
                this.planLibraryList = res.info;
                if (this.planLibraryList.length == 0) {
                    this.showAddBox = true
                }
            })
        },
        getUserTrainPlan() {
            this.$api.trainPlan.getUserTrainPlan({
                conduct: 1
            }).then(res => {
                this.userTrainPlanList = res.info;
            })
        },
        getRepeatWeekText(repeatWeek) {
            let arr = repeatWeek.split(',');
            if (arr.length === 1) {
                return this.$t('setPlanDate.repeatText') + this.$t('setPlanDate.repeatText' + arr[0]);
            } else if (arr.length === 7) {
                return this.$t('setPlanDate.repeatText7')
            } else {
                let text = this.$t('setPlanDate.repeatText');
                for (let i = 0; i < arr.length; i++) {
                    if (i === arr.length - 1) {
                        text = text + this.$t('setPlanDate.repeatText' + arr[i])
                    } else {
                        text = text + this.$t('setPlanDate.repeatText' + arr[i]) + this.$t('setPlanDate.repeatTextSplit');
                    }
                }
                return text;
            }
        },
        createPlan() {
            this.$router.push({
                name: 'planEdit',
                query: {
                    from: 'web',
                    lang: this.$i18n.locale,
                    theme: this.theme
                }
            })
        },
        toPlanDesc(id, type) {
            if (type === 0) {
                this.$router.push({
                    name: 'planDesc',
                    query: {
                        planId: id,
                        lang: this.$i18n.locale,
                        from: 'web',
                        theme: this.theme
                    }
                })
            } else {
                this.$router.push({
                    name: 'planDesc',
                    query: {
                        userPlanId: id,
                        lang: this.$i18n.locale,
                        from: 'web',
                        theme: this.theme
                    }
                })
            }
        }
    }
}
</script>

<style scoped>
.history {
    font-size: 15px;
    color: #00BD9B;
    text-align: right;
    margin: 13px 19px;
    line-height: 19px;
}

.content {
    width: 100%;
    margin-top: 98px;
    color: var(--text-color-1);
}

.create-box {
    width: 345px;
    height: 150px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 0 auto;
    text-align: center;
}

.create-icon {
    width: 166px;
    padding-top: 18px;
}

.create-text {
    font-size: 19px;
}

.box-title {
    font-size: 17px;
    margin-left: 25px;
    margin-bottom: 12px;
}

.progress-box {
    margin-bottom: 25px;
}

.progress-item {
    width: 345px;
    height: 76px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    position: relative;
    margin: 0 auto 10px;
}

.progress-item-title {
    font-size: 17px;
    position: absolute;
    left: 17px;
    top: 14px;
}

.progress-item-group {
    font-size: 12px;
    color: var(--text-color-2);
    position: absolute;
    right: 12px;
    top: 18px;
}

.progress-item-date {
    font-size: 12px;
    color: var(--text-color-2);
    position: absolute;
    left: 17px;
    bottom: 17px;
}

.add-icon {
    width: 26px;
    float: right;
    margin-right: 17px;
}

.progress-item-info {
    position: absolute;
    left: 17px;
    bottom: 17px;
    font-size: 12px;
}

.info-type {
    color: var(--text-color-3);
}

.info-value {
    margin: 0 13px 0 1px;
}

.desc-icon {
    width: 22px;
    position: absolute;
    right: 16px;
    top: 27px;
}
</style>


// WEBPACK FOOTER //
// src/views/trainPlan/07planLibrary.vue